var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-icon-button',_vm._g({key:_vm.$vnode.key || _vm.title,attrs:{"title":_vm.title}},_vm.$listeners),[_c('base-material-design-icon',_vm._b({attrs:{"icon":"send"}},'base-material-design-icon',_vm.iconAttrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }